
function IngredientValidate(values) {

    let errors = {};

    if (!values.Size)
        errors.Size = 'Size is required';

    return errors;
};

export default IngredientValidate;
